export default function search(data, searchKey, searchState) {
    return [...data].filter((e) => {
        var _a;
        return (_a = e[searchKey]) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchState.trim().toLowerCase());
    });
}
export const searchInArrayObject = (data, searchValue) => {
    return data.filter((obj) => searchInObject(obj, searchValue));
};
export const searchInObject = (data, searchValue) => {
    if (data)
        return Object.keys(data).some((key) => {
            var _a;
            if (((typeof data[key] === "string" ||
                typeof data[key] === "number") &&
                (new RegExp("(?:^|\\s)" + searchValue, "i").test(data[key]) ||
                    data[key] ==
                        searchValue)) ||
                (typeof data[key] === "string" &&
                    key == "displayName" &&
                    ((_a = data[key]) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue.toLowerCase())))) {
                return true;
            }
            else if (typeof data[key] === "object") {
                return searchInObject(data[key], searchValue);
            }
            else {
                return false;
            }
        });
};
export const searchMultipleKeys = (data, searchKey, searchState) => {
    let regex = new RegExp(searchState);
    let output = data.filter((e) => {
        return searchKey.some((k) => {
            var _a, _b;
            return (_b = (_a = e[k]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchState === null || searchState === void 0 ? void 0 : searchState.toLocaleLowerCase());
        });
    });
    return output;
};
export const findObjectsByValue = (arr, searchString) => {
    return arr.filter((obj) => Object.values(obj).some((value) => {
        if (typeof value === "string") {
            return value.toLowerCase().includes(searchString.toLowerCase());
        }
        else if (typeof value === "number" || typeof value === "boolean") {
            return String(value).includes(searchString);
        }
        else if (typeof value === "object" && value !== null) {
            return findObjectsByValue([value], searchString).length > 0;
        }
        return false;
    }));
};
